import { Link } from 'react-router-dom';

interface SoldHeroProps {
  totalSoldDisplayed?: number;
}

export default function SoldHero({ totalSoldDisplayed }: SoldHeroProps) {
  return (
    <section className="relative bg-gradient-to-br from-[#1A2332] via-[#2C3E55] to-[#1A2332] text-white pt-16 lg:pt-20 pb-20">
      <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/099848e9ac4069b72077b35d354265e5.jpg')] bg-cover bg-center opacity-10"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center mt-8">
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-6">
            <i className="ri-check-line text-[#E8B84B]"></i>
            <span className="text-sm font-medium">Real Deals. Real People.</span>
          </div>

          <h1 className="font-oswald text-5xl md:text-6xl font-bold mb-6">
            Gone — But{' '}
            <span className="text-[#E8B84B]">Not Forgotten</span>
          </h1>

          <p className="text-xl text-white/90 mb-8 leading-relaxed">
            Every vehicle here went to a real buyer who skipped the dealership games and paid a fair price. 
            No markups. No pressure. No regrets. Yours could be next.
          </p>

          <div className="flex flex-wrap justify-center gap-4">
            <Link
              to="/inventory"
              className="inline-flex items-center gap-2 bg-[#E8B84B] text-[#1A2332] px-8 py-4 rounded-lg font-semibold hover:bg-[#D4A43A] transition-colors whitespace-nowrap"
            >
              <i className="ri-car-line text-xl"></i>
              View Current Inventory
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm text-white border border-white/30 px-8 py-4 rounded-lg font-semibold hover:bg-white/20 transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-line text-xl"></i>
              Contact Us
            </Link>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-wrap justify-center gap-6 mt-12">
            <div className="flex items-center gap-2 text-sm">
              <i className="ri-user-heart-line text-[#4ADE80] text-xl"></i>
              <span>Every buyer paid a fair price</span>
            </div>
            <div className="flex items-center gap-2 text-sm">
              <i className="ri-shield-check-line text-[#4ADE80] text-xl"></i>
              <span>$250 flat doc fee — always</span>
            </div>
            <div className="flex items-center gap-2 text-sm">
              <i className="ri-heart-line text-[#4ADE80] text-xl"></i>
              <span>$100 per sale to Oregon Dog Rescue</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
